export const tr = {
    found: 'Bulunan:',
    of: '/',
    selected: 'Seçilen:'
};
